// AddCategoryModal.tsx - Dedicated component for the "Agregar Categoría" modal
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import './AddCategoryModal.scss';

interface AddCategoryModalProps {
  show: boolean;
  onHide: () => void;
  onAddExisting: () => void;
  onCreateNew: () => void;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  show,
  onHide,
  onAddExisting,
  onCreateNew,
}) => {
  const handleAddExisting = () => {
    onAddExisting();
    onHide();
  };

  const handleCreateNew = () => {
    onCreateNew();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="add-category-modal">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Agregar Categoría</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="category-options-container">
          <div className="category-option" onClick={handleAddExisting}>
            <span className="option-title">Agregar existente</span>
            <p className="option-description">
              Puedes elegir entre categorías que ya tengas creadas
            </p>
          </div>
          <div className="category-option" onClick={handleCreateNew}>
            <span className="option-title">Crear categoría</span>
            <p className="option-description">
              Una categoría desde cero
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddCategoryModal;
